import React from 'react'
import { Auth } from '../../containers'
import { SignUpForm } from './SignUpForm'

export const SignUpPage = () => <Auth>
  <SignUpForm />
</Auth>